import { IMobileStore, NetworkStates } from "../store/mobile/types";
import { DriveStore } from "../store/reducers";
import * as logger from "../utils/logger";
import { observeStore } from "../utils/store";

export default function startLoggingChanges(store: DriveStore) {
    let logGpsConnectionChanged = () => {
        logger.event(store.getState().mobile.gpsConnected ? logger.Event.GPSCONNECT : logger.Event.GPSFAILURE, "GPS connection change");
    };

    let logDeviceCommunicatingChanged = () => {
        let loggerEvent = store.getState().mobile.deviceCommunicating ? logger.Event.NETWORKONLINE : logger.Event.NETWORKOFFLINE;
        logger.event(
            loggerEvent,
            `deviceCommunicating=${ store.getState().mobile.deviceCommunicating }; online=${ store.getState().mobile.online ? NetworkStates[store.getState().mobile.online as NetworkStates] : "" }`
        );
    };

    let logBackgroundChanged = () => {
        logger.event(store.getState().mobile.background ? logger.Event.BACKGROUND : logger.Event.FOREGROUND, `Background state change to ${ store.getState().mobile.background }`);
    };

    let logChargingChanged = () => {
        logger.event(store.getState().mobile.charging ? logger.Event.CHARGING : logger.Event.BATTERY, "Switched charging status");
    };

    const logOnlineStatusChanged = () => {
        const state = (store.getState().mobile as IMobileStore).online;
        logger.event(
            state === NetworkStates.ONLINE ? logger.Event.NETWORKONLINE : logger.Event.NETWORKOFFLINE,
            state || "UNKNOWN"
        );
    };

    let logIoxAttachedChanged = () => {
        logger.event(store.getState().mobile.ioxAttached ? logger.Event.IOXATTACHED : logger.Event.IOXDETACHED, "IOX cable connection change");
    };

    observeStore(store, state => state.mobile.gpsConnected, logGpsConnectionChanged);
    observeStore(store, state => state.mobile.deviceCommunicating, logDeviceCommunicatingChanged);
    observeStore(store, state => state.mobile.background, logBackgroundChanged);
    observeStore(store, state => state.mobile.charging, logChargingChanged);
    observeStore(store, state => state.mobile.online, logOnlineStatusChanged);
    observeStore(store, state => state.mobile.ioxAttached, logIoxAttachedChanged);
}